import { FC, ReactNode } from 'react';

interface AvatarProps {
  src?: string;
  alt: string;
  fallback: ReactNode;
}

const AiAgentAvatar: FC<AvatarProps> = ({ src, alt, fallback }) => (
  <div className="avatar">
    {src ? (
      <img src={src || '/placeholder.svg'} alt={alt} className="avatar-image" />
    ) : (
      <div className="avatar-fallback">{fallback}</div>
    )}
  </div>
);

export default AiAgentAvatar;
